/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReserveTripMapBreaks
 */
export interface ReserveTripMapBreaks {
    /**
     * 
     * @type {string}
     * @memberof ReserveTripMapBreaks
     */
    startTs?: string;
    /**
     * 
     * @type {string}
     * @memberof ReserveTripMapBreaks
     */
    endTs?: string;
    /**
     * 
     * @type {string}
     * @memberof ReserveTripMapBreaks
     */
    locCoords?: string;
    /**
     * 
     * @type {string}
     * @memberof ReserveTripMapBreaks
     */
    cityName?: string;
}

export function ReserveTripMapBreaksFromJSON(json: any): ReserveTripMapBreaks {
    return ReserveTripMapBreaksFromJSONTyped(json, false);
}

export function ReserveTripMapBreaksFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReserveTripMapBreaks {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'startTs': !exists(json, 'start_ts') ? undefined : json['start_ts'],
        'endTs': !exists(json, 'end_ts') ? undefined : json['end_ts'],
        'locCoords': !exists(json, 'loc_coords') ? undefined : json['loc_coords'],
        'cityName': !exists(json, 'city_name') ? undefined : json['city_name'],
    };
}

export function ReserveTripMapBreaksToJSON(value?: ReserveTripMapBreaks | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'start_ts': value.startTs,
        'end_ts': value.endTs,
        'loc_coords': value.locCoords,
        'city_name': value.cityName,
    };
}


